import {ReactComponent as FoodIcon} from "../../../assets/images/icons/food.svg";

export const CardDesktop = ({ children, rest: { unit = '1', price = '0', name = 'Unknown', description = '', weight = null }, img }) => {

   

    return (
        <div className="card">
            <div className="card-img-top position-relative">
                {img ? (
                    <img src={img} alt={name} />
                ) : (
                    <FoodIcon className="default-img" />
                )}
                {children.length > 1 && (
                    <div className="wrap-like position-absolute top-0 end-0 m-2 px-1">
                        {children[0]}
                    </div>
                )}
            </div>
            <div className="card-body">
                <span className="card-title h5">{name}</span>
                {description && <p className="card-text">{description}</p>}
                {weight && <p><span className="fw-bold">Вага:</span> {weight}г</p> }
               
            </div>
            <div
                className="card-footer d-flex justify-content-between align-items-center"
                style={{ height: 60 }}
            >
                <div>
                    <span className="h5">{price}</span>
                    <span className="for-unit">{children[1]}</span>
                </div>
                {children.length > 1 && <div>{children[2]}</div>}
            </div>
        </div>
    );
};
